import { FC } from 'react';
import { Stack } from '@mui/material';
import { ShopDisabledFeatureAlert } from 'containers/shop';
import { ROUTES } from 'config';
import { useTranslation } from 'react-i18next';
import { Button, Footer } from 'melp-design/components';
import { useRouteParams } from 'utils/useIdParam';
import { useBenefit } from 'store/benefits';
import { MarketplaceWithinBenefit } from './MarketplaceWithinBenefit';

interface Props {
  onSaveSuccess: () => void;
  guided: boolean;
}

const Marketplace: FC<Props> = ({ onSaveSuccess, guided }) => {
  const { t } = useTranslation();
  const { id: benefitId } = useRouteParams(ROUTES.benefits.details);
  const { data: benefit } = useBenefit(benefitId);

  if (!benefit) return null;

  return (
    <>
      <Stack gap={2}>
        <ShopDisabledFeatureAlert />

        <MarketplaceWithinBenefit
          benefitId={benefit.id}
          benefitCategory={benefit.type}
        />
      </Stack>

      <Footer visible={guided}>
        <Stack direction="row" justifyContent="end" gap={1}>
          <Button
            label={t('common.continue')}
            variant="primary"
            onClick={() => {
              onSaveSuccess();
            }}
          />
        </Stack>
      </Footer>
    </>
  );
};

export default Marketplace;
